module.exports = __webpack_public_path__ + "img/arrow_right_red.93c2c6ae.svg";